import React from "react";

export default function LoadingSpinner({ message = "Loading…" }) {
  return (
    <div style={styles.wrap}>
      <div style={styles.ring} />
      <p style={styles.text}>{message}</p>
    </div>
  );
}

const styles = {
  wrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "var(--space-16)",
    gap: "var(--space-4)",
  },
  ring: {
    width: 32,
    height: 32,
    border: "3px solid var(--color-bg-inset)",
    borderTopColor: "var(--color-accent)",
    borderRadius: "var(--radius-full)",
    animation: "cg-spin 0.7s linear infinite",
  },
  text: {
    fontSize: "var(--text-sm)",
    color: "var(--color-text-tertiary)",
  },
};

if (typeof document !== "undefined" && !document.getElementById("cg-spin-kf")) {
  const s = document.createElement("style");
  s.id = "cg-spin-kf";
  s.textContent = "@keyframes cg-spin { to { transform: rotate(360deg); } }";
  document.head.appendChild(s);
}
